import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ButtonGroup', null, { withChildren: true });
